import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Spinner } from "@/components/common";
import { useMeta } from "@/hooks/useMeta";

export default function Unsubscribe() {
  useMeta("Unsubscribe");
  const [params] = useSearchParams();
  const [state, setState] = useState<{ ok?: boolean; error?: string }>({});
  useEffect(() => {
    api.post("/newsletter/unsubscribe", { email: params.get("email") || "", t: params.get("t") || "" })
      .then(() => setState({ ok: true })).catch((e) => setState({ error: errMsg(e) }));
  }, [params]);
  return (
    <div className="max-w-xl mx-auto px-5 py-28 text-center" data-testid="unsubscribe-page">
      {!state.ok && !state.error && <Spinner />}
      {state.ok && (
        <>
          <p className="eyebrow text-[var(--c-primary)]">Unsubscribed</p>
          <h1 className="font-display text-3xl md:text-4xl font-light mt-4" data-testid="unsubscribe-success">You won't receive our emails any more</h1>
          <p className="text-neutral-600 mt-5">Changed your mind? You can sign up again at any time using the form at the bottom of any page.</p>
        </>
      )}
      {state.error && <p className="text-red-700" data-testid="unsubscribe-error">{state.error}</p>}
      <Link to="/" className="btn-ink inline-block mt-10 px-9 py-3.5 text-xs tracking-widest uppercase" data-testid="unsubscribe-home">Back to the store</Link>
    </div>
  );
}
